import { customerFullName, v2_useAuthorizedCustomer } from '@crocodille/common';
import NavList from '@components/nav-list/nav-list';
import { useMedia } from '@hooks/use-media';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../modules/auth';
import { ACCOUNT_REGISTER, ACCOUNT_SETTINGS } from '../../routing';

const MainNavigationAccount = () => {
  const { t } = useTranslation();
  const { data: customer } = v2_useAuthorizedCustomer();

  const { signIn, signOut } = useAuth();

  const isAccountStatusInMenu = useMedia('account-status-in-menu');

  return (
    <>
      {!customer && (
        <>
          {isAccountStatusInMenu ? (
            <NavList.Item onClick={() => signIn()}>
              <a>{t('account.login')}</a>
            </NavList.Item>
          ) : null}
          <NavList.Item>
            <Link href={ACCOUNT_REGISTER} prefetch={false}>
              {t('account.register')}
            </Link>
          </NavList.Item>
        </>
      )}
      {customer && isAccountStatusInMenu ? (
        <>
          <NavList.Item>
            <Link href={ACCOUNT_SETTINGS} prefetch={false}>
              {customerFullName(customer)}
            </Link>
          </NavList.Item>
        </>
      ) : null}
      {customer ? (
        <>
          <NavList.Item>
            <button onClick={() => signOut()}>{t('account.logout')}</button>
          </NavList.Item>
        </>
      ) : null}
    </>
  );
};

export default MainNavigationAccount;
